import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Select,
  Space,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import {
  ExclamationCircleOutlined,
  FilterFilled,
  UploadOutlined,
  EyeOutlined,
  UndoOutlined,
  DownOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

const { RangePicker } = DatePicker;

const Search = Input.Search;
// Uploads now go through the backend (POST /admin/media/upload), which
// holds the real AWS credentials server-side and never exposes them. This
// used to upload straight to S3 from the browser with a hardcoded access
// key + secret baked into this file — visible to anyone via view-source on
// the deployed site, no login required. See MediaUploadController.ts.

let baseURL = apiPath.teamManager;
const getPermissionByName = (moduleName) => {
  try {
    const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");

    // If user is admin, return full permissions for any module
    if (user.type === "Admin") {
      return { view: true, add: true, edit: true, delete: true };
    }
    // Case/whitespace-insensitive match — see BlogTabs.js's identical fix.
    const normalizedTarget = String(moduleName || "").trim().toLowerCase();
    const permissions = user?.roleId?.permission || [];
    return (
      permissions.find(
        (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
      ) || {}
    );
  } catch {
    return {};
  }
};

function TeamManager() {
  // const { userPermission, userProfile } = useContext(AuthContext) || { userPermission: [] };
  // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>permission>>>>>>>>>>",userPermission)
  // const isAdmin = userProfile?.type|| "";
  // let permissionObject = {
  //   add:true,
  //   edit:true,
  //   delete:true
  // };
  // const permissionMap = (userPermission ?? []).reduce((acc, item) => {
  //   acc[item.name] = item;
  //   return acc;
  // }, {});
  // console.log(permissionMap)

  // if(isAdmin !== "Admin" && permissionMap["teamManager"]) {
  //   permissionObject.add = permissionMap["teamManager"].add;
  //   permissionObject.edit = permissionMap["teamManager"].edit;
  //   permissionObject.delete =  permissionMap["teamManager"].view;
  //   console.log(permissionMap["teamManager"]);
  //   console.log(permissionObject);
  // }

  const teamManagerPermission = getPermissionByName("teamManager");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const columns = [
    {
      title: "Profile",
      dataIndex: "profilePic",
      key: "profilePic",
      render: (_, { profilePic }) => {
        console.log(profilePic, "profileImage");

        if (!profilePic) {
          return (
            <div className="main-new-class-image-no">
              <img src={Noimage} />
            </div>
          );
        }

        return (
          <Image
            src={profilePic}
            alt="Profile"
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "5px",
              objectFit: "cover",
            }}
          />
        );
      },
    },
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role Name",
      dataIndex: "roleId",
      key: "roleId",
      render: (_, { roleId }) => {
        return <div>{roleId?.name}</div>;
      },
    },
    {
      title: "Customer Name(s)",
      dataIndex: "customerId",
      key: "customerId",
      render: (_, { customerId }) => {
        if (!Array.isArray(customerId) || customerId.length === 0) return "-";

        return (
          <div>
            {customerId.map((cust, index) => (
              <div key={index}>{cust?.name || cust}</div>
            ))}
          </div>
        );
      },
    },
    {
      title: "STATUS",
      key: "isActive",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "InActive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      // filtered: true,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag
            onClick={(e) => (!is_deleted ? showConfirm(_id) : null)}
            color={color}
            key={isActive}
          >
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Registartion date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              {/* <Button
                title="View"
                onClick={(e) => {
                  setVisibleView(true);
                  setViewData(record);
                }}
              >
                <i class="fa fa-light fa-eye"></i>
              </Button> */}
              {teamManagerPermission.edit && (
                <Button
                  title="Edit"
                  onClick={() => {
                    record?.image && setFile([record.image]);

                    // let newRecord = { ...record };

                    // newRecord.mobileNumber =
                    //   newRecord.countryCode + newRecord.mobileNumber;
                    console.log(record, "record>>>>>>>>>>>>>>>>>>>>>>>");
                    setSelected(record);

                    setVisible(true);
                  }}
                >
                  <i class="fa fa-light fa-pen"></i>
                </Button>
              )}

              {teamManagerPermission.edit && (
                <Button
                  title="Reset Password"
                  onClick={() => {
                    setSelected(record);
                    setProvideSession(true);
                  }}
                >
                  <i class="fa fa-key" title="Change Password">
                    {/* Reset password */}
                  </i>
                </Button>
              )}
              {teamManagerPermission.delete && (
                <Button
                  title="Delete User"
                  onClick={(e) => showConfirm1(record._id)}
                >
                  <i class="fas fa-trash"></i>
                </Button>
              )}

              {/* <Button
                title="View Listings"
                onClick={(e) => {
                  navigate("/view-user-list/" + record._id);
                  // setViewData(record);
                }}
              >
                <i class="fas fa-list"></i>
              </Button> */}
            </div>
          </>
        );
      },
    },
  ];

  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post(`${apiPath.baseURL}admin/media/upload`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return { Location: res.data?.data?.url };
  };

  const roleData = () => {
    request({
      url: `${baseURL}/roleData?status=active`,
      method: "get",
      onSuccess: (data) => {
        setRoleList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const customerData = () => {
    request({
      url: `${baseURL}/customer-list?status=active`,
      method: "get",
      onSuccess: (data) => {
        console.log(">>>>>>>>>>>>>???", data);
        setCustomerList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  useEffect(() => {
    if (!teamManagerPermission?.view) {
      navigate("/dashboard");
    }
  }, [teamManagerPermission?.view]);
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const deleteUser = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/delete-account/${record}`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const showConfirm1 = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want delete this Team ? </Button>,
        onOk() {
          deleteUser(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
    roleData();
    customerData();
  }, [refresh, debouncedSearchText, startDate, endDate, filter]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-user/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}&customerId=${filter?.customer ? filter?.customer : ""
        }`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeDate = (e) => {
    if (!e || e.length === 0) {
      setStartDate("");
      setEndDate("");
      setPagination((prev) => ({ ...prev, current: 1 }));
      setRefresh((prev) => !prev); // Trigger data reload
      return;
    }

    setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
    setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleSetRoleById = (id) => {
    const selectedRole = roleList.find((role) => role._id === id);
    if (selectedRole) {
      setFilter((prev) => ({
        ...prev,
        role: {
          label: selectedRole.name,
          value: selectedRole._id,
        },
      }));
    }
  };
  return (
    <>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Team Manager"
              extra={
                <Space wrap size={[10, 10]} align="center" className="gfx-toolbar">
                  <Search
                    size="large"
                    placeholder="Search by Name, Email"
                    onChange={onSearch}
                    title="Search by Name, Email"
                    value={searchText}
                    onPressEnter={onSearch}
                  />

                  <RangePicker
                    value={
                      startDate && endDate
                        ? [
                          moment(startDate, "YYYY-MM-DD"),
                          moment(endDate, "YYYY-MM-DD"),
                        ]
                        : null
                    }
                    onChange={handleChangeDate}
                  />

                  {/* <Button
                    type="primary"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button> */}
                  <Select
                    placeholder="Select a customers"
                    options={customerList.map((customer) => ({
                      label: customer.name,
                      value: customer._id,
                    }))}
                    value={filter?.customer} // controlled value
                    onChange={(selected) => {
                      setFilter((prev) => ({
                        ...prev,
                        customer: selected,
                      }));
                      setPagination((prev) => ({ ...prev, current: 1 }));
                    }}
                  />

                  {teamManagerPermission.add && (
                    <Button
                      type="primary"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Team Member
                    </Button>
                  )}
                  {/* Icon-only refresh — re-fetches this page's data in place
                      instead of making the user hard-reload the browser
                      tab, per direct request (same button added to
                      BrandManager.js/User.js and every other admin list
                      module). Replaces the old text "Reset" button, which
                      cleared every filter/search/date too — this one only
                      refetches, it doesn't touch filter state. */}
                  <Button
                    type="primary"
                    icon={<ReloadOutlined />}
                    title="Refresh"
                    onClick={() => setRefresh((prev) => !prev)}
                  />
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>
    </>
  );
}

const AddFrom = ({
  show,
  hide,
  data,
  refresh,
  handleChangeImage,
  file,
  setFile,
}) => {
  const [mobileNumber, setMobileNumber] = useState({
    mobile_number: "",
    country_code: "",
  });
  const [roleList, setRoleList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const [images, setImages] = useState();
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

  const handleImage = (data) => {
    data.length > 0 ? setImage(data?.[0]?.url) : setImage("");
  };

  const handleImages = (newImages) => {
    setImages(newImages); // Appends instead of replacing
  };

  const handleChange = (value, data) => {
    var country_code = data.dialCode;
    setMobileNumber({
      country_code: country_code,
      mobile_number: value.slice(data.dialCode.length),
    });
  };

  const roleData = () => {
    request({
      url: `${baseURL}/roleData?status=active`,
      method: "get",
      onSuccess: (data) => {
        console.log(">>>>>>>>>>>>>???", data);
        setRoleList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const customerData = () => {
    request({
      url: `${baseURL}/customer-list?status=active`,
      method: "get",
      onSuccess: (data) => {
        console.log(">>>>>>>>>>>>>???", data);
        setCustomerList(data?.data?.list);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    roleData();
    customerData();
    if (!data) return;
    form.setFieldsValue({
      ...data,
      image: data?.image,
      images: data?.images,
      mobile:
        data.countryCode && data.mobileNumber
          ? data.countryCode + data.mobileNumber
          : "",
      roleId: data.roleId?._id,
      customers: Array.isArray(data.customerId)
        ? data.customerId.map((c) => c._id)
        : [], // Assuming customerId is an array of objects
    });

    setMobileNumber({
      country_code: data.countryCode,
      mobile_number: data.mobileNumber,
    });
    setImage(data?.profilePic);
    setImages(data?.images);
  }, [data]);

  const onCreate = (values) => {
    const { email, name, ar_name, roleId } = values;
    if (!email) return ShowToast("Please enter valid email ", Severty.ERROR);

    // setLoading(true);
    const payload = {};
    payload.email = email;
    payload.name = name;
    payload.ar_name = ar_name;
    payload.countryCode = mobileNumber.country_code;
    payload.mobileNumber = mobileNumber.mobile_number;
    payload.profilePic = image?.length > 0 ? image : "";
    payload.images = images?.length > 0 ? images : "";
    payload.roleId = roleId;
    payload.customerId = values.customers;
    console.log(payload);

    request({
      url: `${data ? `${baseURL}/edit-user/${data._id}` : `${baseURL}/add-user`
        }`,
      method: `${data ? "PUT" : "POST"}`,
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast("Team member created successfully", Severty.SUCCESS);
          hide();
          refresh();
          setFile([]);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      title={`${data ? "Edit Team Member" : "Add New Team Member"} `}
      okText="Ok"
      onCancel={hide}
      width={720}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[24, 0]}>
          <Col span={24} md={12}>
            <Form.Item
              label="Name of Team"
              name="name"
              rules={[
                { required: true, message: "Please input the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
                {
                  max: 50,
                  message: "Name cannot exceed 50 characters",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item label="User Role" name="roleId" rules={[{ required: true, message: "Please select a role!" }]}>
              <Select
                placeholder="Select a role"
                options={roleList.map((role) => ({
                  label: role.name,
                  value: role._id, // use _id, not name
                }))}
              />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              label="Select Customers"
              name="customers"
              rules={[
                {
                  required: true,
                  message: "Please select at least one customer",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Customers"
                suffixIcon={<DownOutlined />}
                options={customerList.map((customer) => ({
                  label: customer.name, // or any property like customer.fullName
                  value: customer._id, // assuming _id is the identifier
                }))}
              />
            </Form.Item>
          </Col>
          {/* <Col span={24} sm={12}>
            <Form.Item
              label={`Name Arabic`}
              name="ar_name"
              rules={[
                {
                  required: true,
                  message: "Arabic Name is required",
                },
                {
                  max: 50,
                  message: "Name should not contain more then 50 characters!",
                },
                {
                  min: 2,
                  message: "Name should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`أدخل اسم الفئة`} />
            </Form.Item>
          </Col> */}

          <Col span={24} md={12}>
            <Form.Item
              className=""
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(lang("Image is required")));
                  },
                },
              ]}
              // label={lang("Upload Image")}
              name="profilePic"
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"Profile"}
                btnName={lang("Image")}
                onChange={(data) => handleImage(data)}
                isDimension={false}
              />
            </Form.Item>
            <p className="img-size-details">
              **
              {lang(
                "Images should be for best view in gallery image. You can select only (.png, .jpeg, .jpg) format files upto 5 MB file size"
              )}
              ..!!!
            </p>
            {
              <div className="mt-2 add-img-product">
                {" "}
                {image ? (
                  <Image width={120} src={image ?? notfound}></Image>
                ) : (
                  ""
                )}{" "}
              </div>
            }
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please input the email!" },
                {
                  type: "email",
                  message: "The input is not valid  E-mail!",
                },
                {
                  max: 100,
                  message: "Email cannot exceed 100 characters",
                },
              ]}
            >
              <Input placeholder="Enter Email Address" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              placeholder="Enter a new password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  max: 100,
                  message: "Password cannot exceed 100 characters",
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
                },
              ]}
            >
              <Input.Password placeholder="Enter a new password" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              placeholder="Enter a confirm password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Enter a confirm password" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default TeamManager;
